// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"select_Wrapper__2WHJA","Label":"select_Label__N8khc","Select":"select_Select__3qMeP"};